<div class="row">
  <div id="no-fixed-height" class="col-xl-12 col-lg-12 margin-top-16">
      <div>
        <div class="metric-container">
          <div [ngStyle]="{order: activeTechnicians>0 ? 0 : 1}">
            <app-overview-widget 
              [busy]="techniciansBusy"
              [metric]="activeTechnicians"
              [total]="technicians.length===0 ? 1 : technicians.length"
              metricName="{{'bikeshop.quicklaunch.active_technicians' | translate}}" 
              [type]="overviewActionTypes.USERS"
              videoTooltip="{{ 'bikeshop.quicklaunch.tooltip.active_technicians' | translate}}"
              actionText="{{ 'bikeshop.quicklaunch.goto_user_admin' | translate}}" (video)="tutorialAction($event)"
              (action)="overviewAction($event)">
            </app-overview-widget>
          </div>
          <div [ngStyle]="{order: activeServiceTypes>0 ? 0 : 1}">
            <app-overview-widget 
              [busy]="busyServiceTypes"
              [metric]="activeServiceTypes"
              [total]="serviceTypes.length ===0 ? 1 : serviceTypes.length"
              metricName="{{'bikeshop.quicklaunch.active_servicetypes' | translate}}"
              [type]="overviewActionTypes.SERVICE_TYPES"
              videoTooltip="{{ 'bikeshop.quicklaunch.tooltip.active_servicetypes' | translate}}"
              actionText="{{ 'bikeshop.quicklaunch.goto_service_types' | translate}}"
              (video)="tutorialAction($event)" (action)="overviewAction($event)">
            </app-overview-widget>
          </div>
          <div [ngStyle]="{order: activeMessageTemplates>0 ? 0 : 1}">
            <app-overview-widget 
              [busy]="busyMessages"
              [metric]="activeMessageTemplates"
              [total]="messageTemplates.length === 0 ? 1 : messageTemplates.length"
              metricName="{{'bikeshop.quicklaunch.active_messagetemplates' | translate}}"
              [type]="overviewActionTypes.MESSAGE_TEMPLATES"
              videoTooltip="{{ 'bikeshop.quicklaunch.tooltip.active_messagetemplates' | translate}}"
              actionText="{{ 'bikeshop.quicklaunch.goto_message_templates' | translate}}"
              (video)="tutorialAction($event)" (action)="overviewAction($event)">
            </app-overview-widget>
          </div>
          <div [ngStyle]="{order: cyclists.length>0 ? 0 : 1}">
            <app-overview-widget 
              [busy]="busyCyclists"
              [metric]="linkedCyclists" 
              [total]="linkedCyclists===0 ? 1 : linkedCyclists"
              metricName="{{'bikeshop.quicklaunch.customers' | translate}}" 
              [type]="overviewActionTypes.CUSTOMERS"
              videoTooltip="{{ 'bikeshop.quicklaunch.tooltip.customers' | translate}}"
              actionText="{{ 'bikeshop.quicklaunch.goto_customers' | translate}}" (video)="tutorialAction($event)"
              (action)="overviewAction($event)">
              ></app-overview-widget>
          </div>
          <div [ngStyle]="{order: posProducts > 0 ? 0 : 1}">
            <app-overview-widget 
              [busy]="busyPosProducts"
              [metric]="posProducts === -1 ? 0 : posProducts"
              [total]="posProducts === -1 ? 0 : posProducts"
              metricName="{{'bikeshop.quicklaunch.pos_product_count' | translate}}"
              [type]="overviewActionTypes.POS_CONFIG"
              videoTooltip="{{ 'bikeshop.quicklaunch.tooltip.pos_config' | translate}}"
              actionText="{{ 'bikeshop.quicklaunch.goto_pos_configuration' | translate}}"
              (video)="tutorialAction($event)" (action)="overviewAction($event)">
            </app-overview-widget>
          </div>
        </div>

      </div>
  </div>
</div>